import { IconButton, Tooltip } from "@mui/material"
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

const ArrowBackButton = ({
    onClick,
    toolTip,
    iconSize = 24
}) => {
    return (
        <>
            <Tooltip title="Back">
                <IconButton component="span" variant="contained" className="mpl-primary-btn" onClick={onClick}>
                    <ArrowBackIosNewIcon sx={{ fontSize: iconSize }} />
                </IconButton>
            </Tooltip>
        </>
    )

}

export default ArrowBackButton